const value = (input) => String(input ?? '').trim();

export const legacyBillLineMatchKey = (line = {}) => [
  value(line.code).toLowerCase(),
  value(line.itemName).toLowerCase(),
  Number(line.unitCost || 0).toFixed(2),
].join('|');

export const seedRemainingBillQuantities = (poLines = [], previousBills = []) => {
  const keyCounts = poLines.reduce((counts, line) => {
    const key = legacyBillLineMatchKey(line);
    counts.set(key, (counts.get(key) || 0) + 1);
    return counts;
  }, new Map());

  const billedByKey = (previousBills || []).flatMap((bill) => bill?.billingItems || [])
    .reduce((totals, line) => {
      const key = legacyBillLineMatchKey(line);
      totals.set(key, (totals.get(key) || 0) + (Number(line.quantity) || 0));
      return totals;
    }, new Map());

  return (poLines || []).flatMap((line) => {
    const key = legacyBillLineMatchKey(line);
    // Legacy BillingItems have no PO/pricing-line id. Only subtract when the
    // PO-side composite is unique; ambiguous lines are left untouched.
    const billed = keyCounts.get(key) === 1 ? (billedByKey.get(key) || 0) : 0;
    const originalQuantity = Number(line.quantity) || 0;
    const quantity = originalQuantity - billed;
    if (!(quantity > 0)) return [];
    const sourceSubTotal = Number(line?._poSourceSubTotal);
    const adjustedSourceSubTotal = Number.isFinite(sourceSubTotal) && originalQuantity > 0
      ? (sourceSubTotal / originalQuantity) * quantity
      : sourceSubTotal;
    const nextLine = { ...line, quantity };
    if (Number.isFinite(adjustedSourceSubTotal)) {
      nextLine._poSourceSubTotal = adjustedSourceSubTotal;
      delete nextLine._poAuthoritativeSubTotal;
    }
    return [nextLine];
  });
};
